(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('PendenciasGridCtrl', PendenciasGridController);

  PendenciasGridController.$inject = [
    '$location'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function PendenciasGridController($location) {
    const vm = this;

    // Controller data
    vm.pendencias = [];

    // Bindable methods
    vm.taskClasses = taskClasses;
    vm.singleDayTask = singleDayTask;
    vm.redirectToTask = redirectToTask;

    // Function declarations
    function taskClasses(parameter) {
      let result = '';

      if (parameter.situacao === 'delayed') {
        result = 'task-delayed';
      } else if (parameter.situacao === 'warning') {
        result = 'task-warning';
      } else if (parameter.situacao === 'ontime') {
        result = 'task-ontime';
      }

      return result;
    }

    function redirectToRecomendation(activeRecommendationsTab, task) {
      const taskStatus = task.status === 1 ? 'em_andamento' : 'aberto';

      const recommendationFilters = {
        status: taskStatus,
        dataInicial: task.dataInicial,
        dataFinal: task.dataFinal
      };

      $location.path('/propriedade')
        .search({
          activeRecommendationsTab,
          sidebar: 'recommendations',
          activeGleba: task.gleba.id,
          gleba: task.gleba.id,
          recommendationFilters: JSON.stringify(recommendationFilters)
        });
    }

    function redirectToTaskRecord(task) {
      const date = moment(task.dataFinal).format(MOMENT_DATE_ENGLISH_FORMAT);
      $location.path('/propriedade')
        .search({
          date,
          historyDate: date,
          sidebar: 'tasks'
        });
    }

    // eslint-disable-next-line complexity
    function redirectToTask(task) {
      const { tipo, tipoPendencia } = task;

      // Recomendação de semeadura
      if (tipo.tipo === 'recomendacao_semeadura') {
        $location.path('/recomendacoes_semeadura');
        return;
      }

      // Recomendação Correção de solo
      if (tipo.tipo === 'recomendacao_defensivo' && tipoPendencia === 'aqila_recomendacao') {
        redirectToRecomendation('correcaoSolo', task);
        return;
      }

      // Recomendação defensivos/pulverização
      if (tipo.tipo === 'recomendacao_defensivo' && tipoPendencia === 'recomendacao_defensivo') {
        redirectToRecomendation('recomendacao', task);
        return;
      }

      // Recomendação adubação de cobertura
      if (tipo.tipo === 'adubacao_cobertura') {
        redirectToRecomendation('adubacao', task);
        return;
      }

      // Tarefas
      if (tipoPendencia === 'tarefa') {
        redirectToTaskRecord(task);
      }
    }

    function singleDayTask(task) {
      return moment(task.dataInicial).isSame(moment(task.dataFinal), 'day');
    }

    function updatePendencias(pendencias) {
      pendencias.forEach((gleba) => {
        gleba.pendencias.forEach((task) => {
          const { dataInicial, dataFinal } = task;
          const now = moment();
          let situacao = 'ontime';
          if (now.isAfter(moment(dataFinal), 'day')) {
            situacao = 'delayed';
          } else if (now.isSameOrAfter(moment(dataInicial), 'day')) {
            situacao = 'warning';
          }
          task.situacao = situacao;
        });
      });

      vm.pendencias = pendencias.filter((gleba) => gleba.pendencias.length > 0);
    }

    // Controller logic

    vm.$onChanges = function $onChanges(changes) {
      if (changes.pendencias && !changes.pendencias.isFirstChange()) {
        updatePendencias(changes.pendencias.currentValue);
      }
    };
  }
}());
